import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useMemo } from "react";

import { useRetailer } from "./useRetailer";

const useRetailerStatusControl = () => {
  const { showR2B, reportedCreationTime, hasPlacedFirstOrder } =
    useRetailerStore([
      "showR2B",
      "reportedCreationTime",
      "hasPlacedFirstOrder",
    ]);

  return {
    showR2B,
    reportedCreationTime,
    hasPlacedFirstOrder,
  };
};

const useRetailerStatusTreatment = () => {
  const { retailer } = useRetailer();

  const showR2B = !!retailer && !retailer.hide_retailer2_maker;
  const reportedCreationTime = retailer?.reported_creation_time;
  const hasPlacedFirstOrder = !!retailer?.first_order_at;

  return useMemo(
    () => ({
      showR2B,
      reportedCreationTime,
      hasPlacedFirstOrder,
    }),
    [showR2B, reportedCreationTime, hasPlacedFirstOrder]
  );
};

export const useRetailerStatus = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useRetailerStatusTreatment();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useRetailerStatusControl();
};
